import { QueryHookOptions } from '@apollo/client';
import { useApolloClient, useQuery } from '@ts-gql/apollo';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import React from 'react';

export const SEARCH_ENTITIES_QUERY = gql`
  query SearchEntities(
    $searchTerm: String!
    $includeNonEntities: Boolean!
    $take: Float!
  ) {
    searchEntities(
      searchTerm: $searchTerm
      take: $take
      includeNonEntities: $includeNonEntities
    ) {
      cloudId
      name
      endDateUtc
      entityTypeId
      isDeleted
      familyGroupId
    }
  }
` as import('../../__generated__/ts-gql/SearchEntities').type;

export type SearchEntitiesQueryVariables = OperationVariables<
  typeof SEARCH_ENTITIES_QUERY
>;
export type SearchEntitiesQueryResult = OperationData<
  typeof SEARCH_ENTITIES_QUERY
>;
export type SearchEntitiesResult = NonNullable<
  SearchEntitiesQueryResult['searchEntities']
>[number];

export const useSearchEntities = (
  options: QueryHookOptions<
    SearchEntitiesQueryResult,
    SearchEntitiesQueryVariables
  >
) => {
  const variables = options.variables as SearchEntitiesQueryVariables;

  const res = useQuery(SEARCH_ENTITIES_QUERY, {
    context: { service: 'clients' },
    variables,
    ...options,
  });

  return React.useMemo(
    () => ({ ...res, data: res.data?.searchEntities }),
    [res]
  );
};

export const useSearchEntitiesAsync = () => {
  const apolloClient = useApolloClient();

  return React.useCallback(
    async (variables: SearchEntitiesQueryVariables) => {
      const options = {
        context: { service: 'clients' },
        query: SEARCH_ENTITIES_QUERY,
        variables,
      };

      const res = await apolloClient.query(options);

      return {
        ...res,
        data: res.data?.searchEntities,
      };
    },

    [apolloClient]
  );
};
